import React, { Fragment, useEffect, useState } from "react";
import axios from "axios";
import { useTable, usePagination, useSortBy } from "react-table";
import * as IoIcons from "react-icons/io";
import Cookies from "universal-cookie";
import CreaRepositorio from "./Modals/crear/CreaRepositorio";
import EliminarRepositorio from "./Modals/crear/EliminarRepositorio";
import { descargarDocumento } from "./Seguridad/DescargarDocumento";

function InfoRepositorio() {
  const cookies = new Cookies();
  const [list, setList] = useState([]);
  const [list1, setList1] = useState([]);
  const [postEstado, setPostEstado] = useState("");

  useEffect(() => {
    axios
      .get("https://suadesarrollo.azurewebsites.net/api/ObtenerInstituciones", {
        auth: {
          username: "BasicAuth@icontec.org",
          password: "yQLzqmR7eZSuAmQZUqhY",
        },
      })
      .then((response) => setList1(response.data))
      .catch((error) => console.log(error));
  }, []);

  const fetchData = () => {
    const url = `https://suadesarrollo.azurewebsites.net/api/ObtenerArchivosRepositorio?InstitucionId=${
      postEstado || cookies.get("institucionid")
    }`;
    axios
      .get(url, {
        auth: {
          username: "BasicAuth@icontec.org",
          password: "yQLzqmR7eZSuAmQZUqhY",
        },
      })
      .then((response) => setList(response.data))
      .catch((error) => console.log(error));
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleSearch = () => {
    fetchData();
  };

  const columns = React.useMemo(
    () => [
      { Header: "Id", accessor: "id" },
      { Header: "Ciclo", accessor: "ciclo" },
      { Header: "Nombre", accessor: "nombre" },
      { Header: "Año", accessor: "ano" },
      { Header: "Institucion", accessor: "institucionId" },
      {
        Header: "Archivo",
        accessor: "ubicacion",
        Cell: ({ value }) => (
          <button
            className="btn btn-success"
            onClick={() => descargarDocumento(value)}
          >
            Descargar Adjunto
          </button>
        ),
      },
      {
        Header: "Acción",
        Cell: ({ row }) =>
          cookies.get("tipo_Usuario") == 1 ? (
            <EliminarRepositorio id={row.original.id} />
          ) : (
            <button className="btn btn-danger" disabled>
              <IoIcons.IoIosCloseCircle />
            </button>
          ),
      },
    ],
    [],
  );

  const tableInstance = useTable(
    { columns, data: list },
    useSortBy,
    usePagination,
  );
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
  } = tableInstance;

  return (
    <Fragment>
      <div className="container">
        <div className="text-center">
          <div className="container-fluid">
            <div className="card shadow mb-4">
              <div className="card-header py-3">
                <h6 className="m-0 font-weight-bold text-primary">
                  Repositorio de información
                </h6>
              </div>
              <div className="card-body">
                {cookies.get("tipo_Usuario") == 1 && <CreaRepositorio />}
                {cookies.get("tipo_Usuario") != 2 && (
                  <>
                    <select
                      className="btn btn-secondary btn-user btn-block text-left"
                      onChange={(e) => setPostEstado(e.target.value)}
                    >
                      <option value="">Seleccione</option>
                      <option value="">Todos</option>
                      {list1.map((item, index) => (
                        <option key={index} value={item.id}>
                          {item.razon_Social}
                        </option>
                      ))}
                    </select>
                    <button
                      className="btn btn-primary btn-user btn-block"
                      onClick={handleSearch}
                    >
                      Buscar
                    </button>
                  </>
                )}
                <table {...getTableProps()} className="table table-striped">
                  <thead>
                    {headerGroups.map((headerGroup) => (
                      <tr {...headerGroup.getHeaderGroupProps()}>
                        {headerGroup.headers.map((column) => (
                          <th
                            {...column.getHeaderProps(
                              column.getSortByToggleProps(),
                            )}
                          >
                            {column.render("Header")}
                          </th>
                        ))}
                      </tr>
                    ))}
                  </thead>
                  <tbody {...getTableBodyProps()}>
                    {page.map((row) => {
                      prepareRow(row);
                      return (
                        <tr {...row.getRowProps()}>
                          {row.cells.map((cell) => (
                            <td {...cell.getCellProps()}>
                              {cell.render("Cell")}
                            </td>
                          ))}
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
                <div className="pagination">
                  <button
                    onClick={() => previousPage()}
                    disabled={!canPreviousPage}
                    className="btn btn-primary"
                  >
                    Anterior
                  </button>
                  <button
                    onClick={() => nextPage()}
                    disabled={!canNextPage}
                    className="btn btn-primary"
                  >
                    Siguiente
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

export default InfoRepositorio;
